<template>
	<v-layout row wrap class="activity">
		<v-flex xs12>
			<documents-display-toolbar
				:sortable="false"
				:init-filters="filter"
				@sort="filterAndSort"
				@filter="filterAndSort"
				title="ACTIVITY"
			></documents-display-toolbar>

			<documents-table :filters="filters"></documents-table>
		</v-flex>
	</v-layout>
</template>

<script>
import DocumentsDisplayToolbar from "@components/partials/DocumentsDisplayToolbar";
import DocumentsTable from "@components/partials/DocumentsTable";
import { mapGetters, mapActions } from "vuex";

export default {
	data() {
		return {
			filters: null
		};
	},

	props: {
		filter: {
			default: null
		}
	},

	components: { DocumentsDisplayToolbar, DocumentsTable },

	methods: {
		filterAndSort(params) {
			let filters = {};

			Object.assign(filters, params);
			this.$set(this, "filters", filters);
		}
	}
};
</script>
